(() => {
  const STORAGE_KEY = 'medimax_peptides_age_verified_v1';
  const COOKIE_KEY = 'medimax_peptides_age_verified_v1';

  const storage = {
    get() {
      try {
        return window.localStorage.getItem(STORAGE_KEY);
      } catch (e) {
        const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_KEY.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
      }
    },
    set() {
      try {
        window.localStorage.setItem(STORAGE_KEY, 'yes');
      } catch (e) {}
      const maxAge = 60 * 60 * 24 * 365 * 10;
      document.cookie = `${COOKIE_KEY}=yes; path=/; max-age=${maxAge}; SameSite=Lax`;
    }
  };

  class AgeVerifierPopup extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('[data-age-verifier-content]');
      this.declineContent = this.querySelector('[data-age-verifier-decline-content]');
      this.agreeButton = this.querySelector('[data-age-verifier-agree-button]');
      this.declineButton = this.querySelector('[data-age-verifier-decline-button]');
      this.returnButton = this.querySelector('[data-age-verifier-return-button]');
    }

    connectedCallback() {
      const enabled = this.dataset.enable === 'true';
      const designModeSetting = this.dataset.designMode === 'true';
      const isThemeEditor = Boolean(window.Shopify && Shopify.designMode);

      if ((enabled && storage.get() !== 'yes') || (isThemeEditor && designModeSetting)) {
        this.open();
      }

      if (this.agreeButton) {
        this.agreeButton.addEventListener('click', (event) => {
          event.preventDefault();
          storage.set();
          this.close();
        });
      }

      if (this.declineButton) {
        this.declineButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.showDecline();
        });
      }

      if (this.returnButton) {
        this.returnButton.addEventListener('click', (event) => {
          event.preventDefault();
          if (window.history.length > 1) {
            window.history.back();
          } else {
            window.location.href = 'https://www.google.com/';
          }
        });
      }

      if (isThemeEditor) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) this.open();
        });
      }
    }

    open() {
      this.classList.add('is-visible');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mp-age-gate-lock');
    }

    close() {
      this.classList.remove('is-visible');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mp-age-gate-lock');
    }

    showDecline() {
      if (this.content) this.content.classList.add('is-hidden');
      if (this.declineContent) this.declineContent.classList.remove('is-hidden');
      document.documentElement.classList.add('mp-age-gate-lock');
    }
  }

  if (!customElements.get('m-age-verifier-popup')) {
    customElements.define('m-age-verifier-popup', AgeVerifierPopup);
  }
})();
